import {omit, pick} from 'ramda'
import {
  FIELD_NAME_TO_PROPERTY_NAME_MAPPING,
  SELLER_BANK_ACCOUNT_DOCUMENT_INPUT_FIELD_NAMES,
} from './constants'

export const pickDocuments = pick(SELLER_BANK_ACCOUNT_DOCUMENT_INPUT_FIELD_NAMES)

export const omitDocuments = omit(SELLER_BANK_ACCOUNT_DOCUMENT_INPUT_FIELD_NAMES)

const fieldNameToProperty = (fieldName: string): string => {
  if (FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]) {
    return FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]
  }
  return fieldName.replace('sellerBankDetails.', '')
}

export const mapSellerBankAccountToRequest = (formData: Record<string, any>): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [fieldNameToProperty(fieldName), value])
  )

const propertyToFieldName = (propertyName: string): string => {
  if (Object.values(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).includes(propertyName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return Object.entries(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).find(
      ([, value]) => value === propertyName
    )![0]
  }
  return `sellerBankDetails.${propertyName}`
}

const mapSellerBankAccountPropertiesToInputFieldNames = (
  sellerBankAccount: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(sellerBankAccount).map(([propertyName, value]) => [
      propertyToFieldName(propertyName),
      value,
    ])
  )

export const mapSellerBankAccountToFormData = (
  sellerBankAccount: Record<string, any>,
  inputFieldNames: string[]
): Record<string, any> => {
  const mapped = mapSellerBankAccountPropertiesToInputFieldNames(sellerBankAccount)
  return pick(inputFieldNames, mapped)
}
